import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';
import type { MFAType } from 'password-form/utils/constant-values';

export interface MfaMethodType {
  icon: IconName;
  id: MFAType;
  info: string | undefined;
  name: string;
}

export interface MfaConfigMeta {
  phoneNumber?: string;
}

export interface MfaConfig {
  enrolledAt: Date;
  gipDisplayName: MFAType;
  meta: MfaConfigMeta;
}

export const MFA_MODAL = 'mfa_modal';
